module.exports = __webpack_public_path__ + "static/media/help_3.d323b36b.jpg";